import { Rect, Group, Line } from 'react-konva';

export default function RoomRect({
  x,
  y,
  width,
  height,
  fill,
  interactive,
  isSelected,
  room,
  onRoomClick,
  onRoomHover,
  onRoomHoverEnd,
}) {
  return (
    <Group
      x={x}
      y={y}
      listening={interactive}
      onClick={interactive ? () => onRoomClick(room) : undefined}
      onTap={interactive ? () => onRoomClick(room) : undefined}
      onMouseEnter={
        interactive
          ? e => {
              const stage = e.target.getStage();
              if (stage) stage.container().style.cursor = 'pointer';
              onRoomHover(e, room);
            }
          : undefined
      }
      onMouseLeave={
        interactive
          ? e => {
              const stage = e.target.getStage();
              if (stage) stage.container().style.cursor = 'default';
              onRoomHoverEnd();
            }
          : undefined
      }
    >
      <Rect
        width={width}
        height={height}
        fill={fill}
        stroke="#d1d5db"
        strokeWidth={1}
        cornerRadius={0}
        opacity={interactive ? 1 : 0.6}
      />
  
    </Group>
  );
}
